var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fraction-switch",on:{"click":function($event){$event.preventDefault();return _vm.$emit('change', {
        val: !_vm.fraction.enabled,
        fractionId: _vm.fraction.id
    })}}},[_c('a-switch',{attrs:{"id":`fraction-${_vm.fraction.id}`,"checked":_vm.fraction.enabled}}),_c('fraction-label',{attrs:{"show-details":_vm.showDetails,"show-details-tooltip":_vm.showDetailsTooltip,"disabled":!_vm.fraction.enabled,"fraction":_vm.fraction,"active-color":_vm.activeColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }